"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = useTheme;
var _react = require("react");
var _themeContext = _interopRequireDefault(require("../context/theme-context"));
/**
 * @example
 * import { useTheme } from '@mmc/theme-provider'
 *
 * const theme = useTheme()
 */
function useTheme() {
  return (0, _react.useContext)(_themeContext["default"]);
}